// extracted by mini-css-extract-plugin
module.exports = {"root":"Filters_root__U8oNH"};